var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleAdsManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Service Image"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Service Image_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.5 13.9C35.8 16.1 35.9 16 20.3 42C8.5 61.6 8 62.7 8 68C8 78.1 14 84 24.1 84C32 84 35.3 81.5 42 70.3C45 65.2 47.7 61.1 48 61.1C48.3 61.1 51 65.2 54 70.3C60.7 81.5 64 84 71.9 84C82.1 84 88 78.1 88 67.9C88 62.4 87.6 61.6 74.3 39.4C58.7 13.5 57.3 12 48.1 12C44.4 12 41.5 12.6 39.5 13.9ZM52.2 22.2C55.3 24.6 79 65.4 79 68.3C79 73.6 72 77 67.8 73.8C64.7 71.4 41 30.6 41 27.7C41 22.4 48 19 52.2 22.2ZM38.4 44.2C42.2 50.6 42.4 52.6 39.5 56.4C38 58.3 38 58.3 35.8 56.3C32.8 53.6 29.6 52 27.1 52C25.3 52 25.5 51.3 29.3 45C31.6 41.1 33.8 38 34.1 38C34.5 38 36.4 40.8 38.4 44.2ZM29.2 62.7C31.5 64.7 31.6 70.7 29.3 73.2C27.3 75.5 21.3 75.6 18.8 73.3C16.5 71.3 16.4 65.3 18.7 62.8C20.7 60.5 26.7 60.4 29.2 62.7Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAdsManagement);
export default __webpack_public_path__ + "static/media/google-ads-management.b4720c01d1aa8675371eedae6b50f63d.svg";
export { ForwardRef as ReactComponent };